export type CopyReceipt = {
  text: string;
  sessionId?: string;
  parentPasteIds?: string[];
  parentInputPasteIds?: string[];
  ranges?: {startOffset:number;endOffset:number;parentPasteIds:string[];parentInputPasteIds:string[]}[];
};

const marker = 'application/x-immerso-students-copy';
const copies = new Map<string, CopyReceipt>();

export function writeCopyReceipt(data: DataTransfer, receipt: CopyReceipt) {
  const token = crypto.randomUUID();
  copies.clear();
  copies.set(token, receipt);
  data.setData('text/plain', receipt.text);
  data.setData(marker, token);
}

export function readCopyReceipt(data: DataTransfer): CopyReceipt | null {
  const receipt = copies.get(data.getData(marker));
  return receipt?.text === data.getData('text/plain') ? receipt : null;
}
